/* eslint-disable max-len */
import * as grok from 'datagrok-api/grok';
// -- Monomer libraries --
const LIB_STORAGE_NAME = 'Libraries';
const LIB_SETTINGS_KEY = 'Settings';
const DUPLICATE_MONOMER_PREFERENCES_KEY = 'DuplicateMonomerPreferences';
// user settings does not allow more than 5000 characters, but unfortunately we need this, so we will split
// the string into chunks and store them separately
const MAX_USER_SETTINGS_STRING_LENGTH = 4000;
const CHUNK_KEY_SUFFIX = 'nextChunk';
async function getDuplicatePrefsFull() {
    // the first part of it will always live in DUPLICATE_MONOMER_PREFERENCES_KEY
    let resStr = await grok.userSettings.getValue(LIB_STORAGE_NAME, DUPLICATE_MONOMER_PREFERENCES_KEY, true) ?? '';
    if (!resStr)
        return {};
    // chunk will end with special suffix and just before it will have the number of the next chunk key
    let iter = 1;
    while (resStr.endsWith(CHUNK_KEY_SUFFIX)) {
        const nextChunkKeysCount = iter.toString().length;
        const nextChunkIndex = new Array(nextChunkKeysCount).fill(0)
            .reduce((acc, _, i) => acc + resStr.charAt(resStr.length - nextChunkKeysCount + i - CHUNK_KEY_SUFFIX.length), '');
        const nextChunkKey = `${DUPLICATE_MONOMER_PREFERENCES_KEY}${nextChunkIndex}`;
        const nextChunkStr = (await grok.userSettings.getValue(LIB_STORAGE_NAME, nextChunkKey, true)) ?? '';
        resStr = resStr.slice(0, resStr.length - CHUNK_KEY_SUFFIX.length - nextChunkIndex.length) + nextChunkStr;
        iter++;
    }
    try {
        return JSON.parse(resStr);
    }
    catch (err) {
        console.error(`Failed to parse duplicateMonomerPreferences from user settings: ${err}`);
        return {};
    }
}
async function setDuplicatePrefsFull(value) {
    const valueStr = JSON.stringify(value);
    const chunksCount = Math.ceil(valueStr.length / MAX_USER_SETTINGS_STRING_LENGTH);
    for (let i = 0; i < chunksCount; i++) {
        const key = i === 0 ? DUPLICATE_MONOMER_PREFERENCES_KEY : `${DUPLICATE_MONOMER_PREFERENCES_KEY}${i}`;
        const nextKey = i < chunksCount - 1 ? `${i + 1}` : '';
        const chunkStr = valueStr.slice(i * MAX_USER_SETTINGS_STRING_LENGTH, (i + 1) * MAX_USER_SETTINGS_STRING_LENGTH);
        const chunkStrToStore = nextKey ? chunkStr + nextKey + CHUNK_KEY_SUFFIX : chunkStr;
        await grok.userSettings.add(LIB_STORAGE_NAME, key, chunkStrToStore, true);
    }
}
let userLibSettingsPromise = Promise.resolve();
export async function getUserLibSettings() {
    let res;
    userLibSettingsPromise = userLibSettingsPromise.then(async () => {
        const resStr = await grok.userSettings.getValue(LIB_STORAGE_NAME, LIB_SETTINGS_KEY, true);
        res = resStr ? JSON.parse(resStr) : { exclude: [], explicit: [], duplicateMonomerPreferences: {} };
        const duplicatePrefs = await getDuplicatePrefsFull();
        // Fix empty object returned in case there is no settings stored for user
        res.exclude = res.exclude instanceof Array ? res.exclude : [];
        res.explicit = res.explicit instanceof Array ? res.explicit : [];
        res.duplicateMonomerPreferences = res.duplicateMonomerPreferences instanceof Object ?
            res.duplicateMonomerPreferences : {};
        // migrate from short hand if needed
        for (const polymerType in duplicatePrefs) {
            res.duplicateMonomerPreferences[polymerType] = res.duplicateMonomerPreferences[polymerType] ?? {};
            for (const libraryName in duplicatePrefs[polymerType]) {
                for (const monomerSymbol of duplicatePrefs[polymerType][libraryName])
                    res.duplicateMonomerPreferences[polymerType][monomerSymbol] = libraryName;
            }
        }
        // console.debug(`Bio: getUserLibSettings()\n${JSON.stringify(res, undefined, 2)}`);
    });
    await userLibSettingsPromise;
    return res;
}
export async function setUserLibSettings(value) {
    userLibSettingsPromise = userLibSettingsPromise.then(async () => {
        value.duplicateMonomerPreferences = value.duplicateMonomerPreferences ?? {};
        // console.debug(`Bio: setUserLibSettings()\n${JSON.stringify(value, undefined, 2)}`);
        // extract short hand for duplicateMonomerPreferences
        const duplicatePrefsShortHand = {};
        for (const polymerType in value.duplicateMonomerPreferences) {
            duplicatePrefsShortHand[polymerType] = {};
            for (const monomerSymbol in value.duplicateMonomerPreferences[polymerType]) {
                const libraryName = value.duplicateMonomerPreferences[polymerType][monomerSymbol];
                duplicatePrefsShortHand[polymerType][libraryName] = duplicatePrefsShortHand[polymerType][libraryName] ?? [];
                duplicatePrefsShortHand[polymerType][libraryName].push(monomerSymbol);
            }
        }
        await setDuplicatePrefsFull(duplicatePrefsShortHand);
        //await grok.userSettings.add(LIB_STORAGE_NAME, DUPLICATE_MONOMER_PREFERENCES_KEY, JSON.stringify(duplicatePrefsShortHand), true);
        await grok.userSettings.add(LIB_STORAGE_NAME, LIB_SETTINGS_KEY, JSON.stringify(value), true);
    });
    await userLibSettingsPromise;
}
//# sourceMappingURL=lib-settings.js.map